$(document).ready(function () {

    $(".FollowList .UnFollow, .FollowPop .RemoveIcon, .FollowItems .RemoveIcon, .GenGreen, .PrLike.active").live("click", function () {
        var clickedItem = $(this);

        var Silid = $(this).attr("data-id");
        var colorid = $(this).attr("data-colorid");
        var gizlenecekSecim = $(this).closest("div");

        if ($(this).attr("data-followid").length > 0) {

            Silid = $(this).attr("data-followid");
            gizlenecekSecim = null;

            if ($(".HeartIcon").length > 0) {
                gizlenecekSecim = $(this).closest("div.SepetRow");
            }
        }


        var clickedIcon = $(this);
        var LangID = $("#LangID").val();

        $(gizlenecekSecim).css("opacity", "0.5");
         
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
            data: 'productID=' + Silid + '&colorID=' + colorid + "&langID=" + LangID,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {
                if (dt.Sonuc == true) {
                    if ($(gizlenecekSecim).length > 0) {
                        $(gizlenecekSecim).hide("slow");
                    }
                    else {
                        $(clickedIcon).removeClass("GenGreen");
                        $(clickedIcon).val(dt.IslemSonucAciklama);
                        $('.LikeCount').html(dt.Deger4);

                        // favorilerden kaldırılan ürünü gizliyor
                        $(clickedItem).closest(".Prd").slideUp();
                    }

                    //#region Related Datalayer Remove From Favorite Operation
                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                        window.dataLayer.push(JSON.parse(dt.Deger8));
                    }
                    //#endregion

                    $(clickedIcon).removeClass("active");
                    $(clickedIcon).addClass("add");
                    $("button.PrLike").text($("button.PrLike").attr("data-addtext"));

                    $HeartIcon = $(".HeartIcon");

                    if ($HeartIcon.length > 0) {

                        $HeartIconCountItem = $HeartIcon.find(".IconCount");
                        var IconCount = Number($HeartIconCountItem.text());

                        IconCount = IconCount - 1;

                        $HeartIconCountItem.text(IconCount);
                        if (IconCount <= 0) {

                            $HeartIconCountItem.addClass("gizli");
                        }

                        if ($(".HeartIcon div.SepetRow:visible").length - 1 <= 0) {
                            $HeartIcon.addClass("Blank");
                        }
                    }
                }
                else {
                    alert(dt.IslemSonucAciklama);
                }
            }
        });
    });

    $(".AddToCart").each(function () {
        if ($(this).hasClass("passive")) {
            $(this).html("TÜKENDİ");
        }
    });

    $("a.AjaxLink").live("click", function () {

        var callUrl = $(this).attr("href");
        var dynform = $(this).attr("data-dynform");

        $DynformDiv = $("div." + dynform + ":first");

        var dt = "";

        $.ajax({
            type: "GET",
            url: callUrl,
            success: function (data) {

                dt = data;
                $DynformDiv.html(data);


                // Adres formunda fatura bilgileri inputları için
                if ($("#AdresTipi2").is(":checked")) {
                    $(".vergi").show(); $(".tcno").hide();
                }

                if ($("#AdresTipi1").is(":checked")) {
                    $(".vergi").hide(); $(".tcno").show();
                }

                if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "TR"
                    || $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "KKTC") { // TR
                    $(".tr_group").show();
                    $(".stateDiv").hide();
                    $(".cityDiv").hide();

                }

                if (($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "TR"
                    &&
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "KKTC")
                    &&
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "CA"
                    &&
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "US") { //Rest of world

                    $(".tr_group").hide();
                    $(".stateDiv").hide();
                    $(".cityDiv").show();

                }
                if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "CA"
                    ||
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "US") { //USA & CA

                    $(".tr_group").hide();
                    $(".stateDiv").show();
                    $(".cityDiv").show();

                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });



        return false;

    });

    $(".PassChange").live("click", function () {

        $.ajax({
            type: 'POST',
            url: '/' + $("#SmallLangCode").val() + '/p/User/ChangePass',
            data: $(".ChangePassForm").serialize(),
            success: function (dt) {
                $(".cp").html(dt);
            }
        });

        return false;

    });

    $("form.davetform").live("submit", function (e) {

        $form = $(this);

        $.ajax({
            type: $form.attr("method"),
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (data) {

                if ($('.validation-summary-errors').length) {

                    $('.validation-summary-errors')
                        .addClass('alert alert-error');
                }

                $(".AjaxLoader").hide();

                if (data.Sonuc != true) {

                    $form.find(".jsCreated").remove();
                    $form.prepend('<div class="validation-summary-errors alert alert-error jsCreated" data-valmsg-summary="true"><ul><li> ' + data.IslemSonucAciklama + ' </li></ul></div>');

                    return false;
                }
                else {

                    $form.find("div.jsCreated, .validation-summary-valid").remove();
                    $('<div class="validation-summary-valid alert alert-success jsCreated gizle" data-valmsg-summary="true"><ul><li> ' + data.IslemSonucAciklama + '</li></ul></div>').insertBefore($form).slideDown("slow");

                    $(".temizle").val('');


                }


            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        e.preventDefault;
        return false;

    });

    $("form.UserMessageForm").die("submit").live("submit", function () {

        $(".AjaxLoader").show();

        $.ajax({
            type: $(this).attr("method"),
            url: $(this).attr("action"),
            data: $(this).serialize(),
            cache: false,
            success: function (data) {

                $(".MessageBody").html(data);

                $(".AjaxLoader").hide();
            }
        });

        return false;

    });

    if (document.URL.indexOf("/p/User/") > -1 || document.URL.indexOf("/p/Orders/") > -1) {

        $(".grey .menuitem a").each(function (index) {

            var CurUrl = document.URL.split('/p/User/')[1];

            var CurLink = "";

            if (document.URL.indexOf("/p/Orders/") > -1) {

                CurUrl = document.URL.split('/p/Orders/')[1];
                CurLink = $("#SmallLangCode").val() + "/p/Orders/" + $("#AName").val();

            }
            else {
                CurLink = $("#SmallLangCode").val() + "/p/User/" + $("#AName").val();

            }

            if ($(this).attr("href").indexOf(CurLink) > 0) {

                if ($(this).attr("href").indexOf("hb=t") < 0) {
                    $(this).closest("li").addClass("current");

                }
                else if ($(this).attr("href").indexOf("hb=t") > 0 && document.URL.indexOf("hb=t") > -1) {
                    $(".grey li").removeClass("current");
                    $(this).closest("li").addClass("current");
                }
            }

        });

        $(".ToggleAccountMenu").html($(".menuitem.current:first").text() + "<span></span><span></span><i class='glyphicon glyphicon-menu-down' style='float: right;'></i>");

        if ($(".menuitem.current:first").length <= 0) {
            $(".ToggleAccountMenu").html($(".menuitem:first").text() + "<span></span><i class='glyphicon glyphicon-menu-down' style='float: right;'></i>");
        }
    }

    if ($(".HighlightLinkFromUrl").length > 0) {
        $(".HighlightLinkFromUrl a").each(function (index) {
            var CurLink = $("#CName").val() + "/" + $("#AName").val();
            if ($(this).attr("href").indexOf(CurLink) > 0) {
                $(this).addClass("active");
                $(this).parent().addClass("active");
            }
        });
    }

    // Siparişlerim sayfasında kargo takibi bilgilerini görmek için istek yapıp modal'ı ayarlayan event
    $("a.CargoDetailModal").live("click", function (event) {
        event.preventDefault();

        var clickedElement = $(this);
        var OrderModal = $("div#cargoTrackModel");
        var ModalTitle = $("h3.modal-title", OrderModal);
        var ModalContent = $("div.modal-body", OrderModal);

        var CurrentTitle = $(clickedElement).children("td:first").html();

        $(ModalTitle).html($("h3.ModalTitle").text());

        $.get(clickedElement.attr("data-trackFile"), function (data) {
            $(ModalContent).html(data);
        });
    });

    // Telefon numarasına onay kodu gönder
    $(".UyeOlModal #sendConfirmationSmsCode").live("click", function (e) {
        RegisterFormConditionsCheck($(this).closest("form").serialize());

        //sendSmsConfirmationCode(e);
    });
    // Modal'ı kapat
    $("#smsConfirmationModal #closeIcon").live("click", function () {
        clearAndHidErrorAlertResult();
        $("#smsConfirmationModal").hide();
    });

    $(document).on("keyup", "form.UyeOlModal input#UserName", function () {
        var thisValue = $(this).val();

        thisValue = thisValue.replaceAll(" ", "");
        thisValue = thisValue.toLowerCase();
        thisValue = thisValue.turkishtoEnglish();

        $(this).val(thisValue);
    });

    // Onay kodu doğrulama
    // Sms kodu doğrulanırsa  formdaki üye ol butonu değiştirilir ve formu UserAdd methoduna gönderir
    $("#confirmSmsCodeBtn").live("click", function (e) {
        var confirmationCode = $("#smsConfirmationModal #smsConfirmationCode").val();

        if (confirmationCode != undefined && confirmationCode.length == 6) {
            clearAndHidErrorAlertResult();

            $.ajax({
                type: 'POST',
                url: '/' + $("#SmallLangCode").val() + '/p/User/VerifySmsConfirmationCode?confirmationCode=' + confirmationCode,
                success: function (dt) {
                    if (dt.Sonuc) {
                        ClearCloudflareWidgets();

                        // Hata varsa temizle
                        $("#AlertResult").removeClass("alert-error");
                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").html("");
                        $("#AlertResult").hide();

                        // Onay kodu Modal'ı kapat
                        $("#smsConfirmationModal").hide();
                        // Kayıt ol
                        RegisterSubmit();
                        // Formda hata olabilir diye forma register butonu ekle
                        $(".UyeOlModal .Buttons").html(dt.IslemSonucAciklama);

                        $("#AlertResult").html("Sms onaylama işlemi tamalanmıştır.");
                        if (dt.Deger10 === "SkipSms") {
                            RegisterSubmit();
                            return;
                        }
                        $("#AlertResult").addClass("alert-success");
                        $("#AlertResult").show();

                        $("html, body").animate({ scrollTop: 0 }, "slow");
                        $(".UyeOlModal #Gsm").attr("disabled", "disabled"); // numarayı değiştireyi kapat

                        $(".g-recaptcha").remove();

                    } else {
                        $("#AlertResultConfModal").html(dt.IslemSonucAciklama);
                        $("#AlertResultConfModal").addClass("alert alert-danger");
                        $("#AlertResultConfModal").show();
                    }
                }
            });
        } else {
            $("#AlertResultConfModal").html("Lütfen 6 haneli onay kodunu giriniz!");
            $("#AlertResultConfModal").addClass("alert alert-danger");
            $("#AlertResultConfModal").show();
        }
    });

    // Tekrar Sms Gönder
    $(document).on("click", "#LoginRegisterPage #retryConfirmationBtn", function (e) {
        $("#retryConfirmationBtn").addClass("hidden");
        sendSmsConfirmationCode(e);
        SendSmsCountDown();
    });

    if ($(".UyeOlModal #Gsm").length > 0) {
        $(".UyeOlModal #Gsm").mask("999 999 99 99", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });

        $(document).on("keyup", ".UyeOlModal #Gsm", function () {
            var phone = $(this).val();
            var firstChar = phone.substr(0, 1);

            if (firstChar != "5" && phone.length > 1) {
                $(this).val("");
            }
            else if (firstChar != "5") {
                phone = phone.substr(1, phone.length);
                $(this).val(phone);
            }
        });
    }

    $("#sendConfirmMail").live("click", function () {

        $("#confirmMailModal").show();
        $("#confirmMailAddress").val($("#login_UserName").val());
    });

    $("#closeIcon").live("click", function () {
        $("#confirmMailModal").hide();

    });

    if ($("#localPassVM_User_Gsm").length > 0) {
        $("#localPassVM_User_Gsm").mask("999 999 99 99", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });

        $(document).on("keyup", "#localPassVM_User_Gsm", function () {
            var phone = $(this).val();
            var firstChar = phone.substr(0, 1);

            if (firstChar != "5" && phone.length > 1) {
                $(this).val("");
            }
            else if (firstChar != "5") {
                phone = phone.substr(1, phone.length);
                $(this).val(phone);
            }
        });
    }

    // Üye Giriş yönteminin değiştirilmesi (GSM-Email)
    $('.login-type-container input[type=radio][name=IsGsmLogin]').change(function () {
        if (this.value == 'true') {
            $(".UyeGirisModal #PhoneNumber").removeClass("hidden");
            $(".UyeGirisModal #UserName").addClass("hidden");
        }
        else if (this.value == 'false') {
            $(".UyeGirisModal #UserName").removeClass("hidden");
            $(".UyeGirisModal #PhoneNumber").addClass("hidden");
        }
    });

    if ($(".UyeGirisModal #PhoneNumber").length > 0) {
        $(".UyeGirisModal #PhoneNumber").mask("999 999 99 99", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });

        $(document).on("keyup", ".UyeGirisModal #PhoneNumber", function () {
            var phone = $(this).val();
            var firstChar = phone.substr(0, 1);

            if (firstChar != "5" && phone.length > 1) {
                $(this).val("");
            }
            else if (firstChar != "5") {
                phone = phone.substr(1, phone.length);
                $(this).val(phone);
            }
        });
    }

    // Aydınlatma metinlerinin onaylanması (Görünüm)
    $(document).on("click", ".TermsCon label", function () {
        var customCheckView = $(this).find(".customCheck");
        if (customCheckView.hasClass("checked")) {
            customCheckView.removeClass("checked");
        }
        else {
            customCheckView.addClass("checked");
        }
    });

    $(document).on("click", ".GenderCon label", function () {
        $(".GenderCon label .customCheck").removeClass("checked");

        // Seçilen öğeye "checked" sınıfını ekle
        var customCheckView = $(this).find(".customCheck");
        customCheckView.addClass("checked");
    });

    // Üye ol formunu gönder
    $(document).on("click", "#LoginRegisterPage .UyeOlModal #RegisterButton", function () {
        //Üye ol
        RegisterSubmit();
    });

    // ÜYE OL KAMPANYA VE DUYURU CHECKBOX
    // Açık Rıza onay butonunu seçin
    var acikRizaCheckbox = document.getElementById("AllowConsent");

    // İletişim kanalı butonlarını seçin
    var AllowMailCheckbox = document.getElementById("AllowMail");
    var AllowSmsCheckbox = document.getElementById("AllowSms");
    var AllowCallCheckbox = document.getElementById("AllowCall");
    var AllowWhatsappCheckbox = document.getElementById("AllowWhatsapp");

    if (acikRizaCheckbox) {
        // Açık Rıza onay butonuna tıklandığında
        acikRizaCheckbox.addEventListener("click", function () {
            if (acikRizaCheckbox.checked) {
                // Eğer Açık Rıza onayı işaretli ise, iletişim kanallarını işaretle
                AllowMailCheckbox.checked = true;
                AllowSmsCheckbox.checked = true;
                AllowCallCheckbox.checked = true;
                AllowWhatsappCheckbox.checked = true;

                $(".TermsCon label .customCheck").addClass("checked");

            } else {
                // Açık Rıza onayı işareti kaldırılırsa, iletişim kanallarını temizle
                AllowMailCheckbox.checked = false;
                AllowSmsCheckbox.checked = false;
                AllowCallCheckbox.checked = false;
                AllowWhatsappCheckbox.checked = false;

                $(".TermsCon label .customCheck").removeClass("checked");
            }
        });

        // İletişim kanalı butonlarına tıklandığında
        AllowMailCheckbox.addEventListener("click", updateAcikRiza);
        AllowSmsCheckbox.addEventListener("click", updateAcikRiza);
        AllowCallCheckbox.addEventListener("click", updateAcikRiza);
        AllowWhatsappCheckbox.addEventListener("click", updateAcikRiza);

        function updateAcikRiza() {
            if (AllowMailCheckbox.checked || AllowSmsCheckbox.checked || AllowCallCheckbox.checked || AllowWhatsappCheckbox.checked) {
                // Herhangi bir iletişim kanalı seçildiğinde Açık Rıza'yı işaretle
                acikRizaCheckbox.checked = true;
                $(".acikRizaCheckbox").addClass("checked");
            } else {
                // İletişim kanallarının tüm işaretleri kaldırılırsa Açık Rıza'yı temizle
                acikRizaCheckbox.checked = false;
                $(".acikRizaCheckbox").removeClass("checked");
            }
        }
    }

    // HESABIM KAMPANYA VE DUYURU CHECKBOX

    // Açık Rıza onay butonunu seçin
    var acikRizaHesabimCheckbox = document.getElementById("User.AllowConsent");

    // İletişim kanalı butonlarını seçin
    var AllowMailCheckboxUser = document.getElementById("User.AllowMail");
    var AllowSmsCheckboxUser = document.getElementById("User.AllowSMS");
    var AllowCallCheckboxUser = document.getElementById("User.AllowCall");
    var AllowWhatsappCheckboxUser = document.getElementById("User.AllowWhatsapp");

    if (acikRizaHesabimCheckbox) {

        updateAcikRizaUser();

        // Açık Rıza onay butonuna tıklandığında
        acikRizaHesabimCheckbox.addEventListener("click", function () {
            if (acikRizaHesabimCheckbox.checked) {
                // Eğer Açık Rıza onayı işaretli ise, iletişim kanallarını işaretle
                AllowMailCheckboxUser.checked = true;
                AllowSmsCheckboxUser.checked = true;
                AllowCallCheckboxUser.checked = true;
                AllowWhatsappCheckboxUser.checked = true;

                //$(".customCheck").addClass("checked");

            } else {
                // Açık Rıza onayı işareti kaldırılırsa, iletişim kanallarını temizle
                AllowMailCheckboxUser.checked = false;
                AllowSmsCheckboxUser.checked = false;
                AllowCallCheckboxUser.checked = false;
                AllowWhatsappCheckboxUser.checked = false;

                //$(".customCheck").removeClass("checked");
            }
        });

        // İletişim kanalı butonlarına tıklandığında
        AllowMailCheckboxUser.addEventListener("click", updateAcikRizaUser);
        AllowSmsCheckboxUser.addEventListener("click", updateAcikRizaUser);
        AllowCallCheckboxUser.addEventListener("click", updateAcikRizaUser);
        AllowWhatsappCheckboxUser.addEventListener("click", updateAcikRizaUser);

        function updateAcikRizaUser() {
            if (AllowMailCheckboxUser.checked || AllowSmsCheckboxUser.checked || AllowCallCheckboxUser.checked || AllowWhatsappCheckboxUser.checked) {
                // Herhangi bir iletişim kanalı seçildiğinde Açık Rıza'yı işaretle
                acikRizaHesabimCheckbox.checked = true;
                $(".acikRizaHesabimCheckbox").addClass("checked");
            } else {
                // İletişim kanallarının tüm işaretleri kaldırılırsa Açık Rıza'yı temizle
                acikRizaHesabimCheckbox.checked = false;
                $(".acikRizaHesabimCheckbox").removeClass("checked");
            }
        }
    }
});

UserCommentRatingStarts();

$(".rateyo").each(function () {
    var rating = $(this).attr("data-rateyo-rating");
    var percentRating = rating * 20;
    //console.log(percentRating);

    $(this).rateYo(
        {
            //rating: "'" + percentRating + "%" +"'",
            starWidth: "16px",
            ratedFill: "#f39c12",
            halfStar: true,
            readOnly: true,
            spacing: "1px"
        }
    );
});

function UserCommentRatingStarts() {

    RatingStarts();

    $Stars = $("#CommentModal .RateStars");
    $("#CommentModal .modal-footer a").addClass("disabled");
    RateStarsOperation("init");

    // Rate Stars Change Method
    $Stars.rateYo()
        .on("rateyo.set", function (e, data) {
            $("#CommentModal .RateWarning").hide();
            $("#CommentModal .modal-footer a").removeClass("disabled");
        });
}

function DataLayerLoginSignUp(Type, UserID, AllowMail, AllowSms) {

    window.dataLayer = window.dataLayer || [];

    var event = "";

    if (Type == "signup") {
        event = "sign_up"
    }

    const dataLayerObject = {
        'event': event,
        'email_permission': AllowMail,
        'sms_permission': AllowSms,
        'userId': UserID,
    };

    //  console.log(JSON.stringify(dataLayerObject));

    dataLayer.push(dataLayerObject);
}

function RegisterFormConditionsCheck(data) {
    $(".AjaxLoader").show();
    $.ajax({
        type: 'POST',
        data: data,
        url: '/' + $("#SmallLangCode").val() + '/p/User/RegisterFormConditionsCheck',
        success: function (dt) {
            if (dt.Sonuc) {
                sendSmsConfirmationCode(data);

            } else {
                showErrorAlertResult(dt.Deger9);
            }
        }
    });

    $(".AjaxLoader").hide();
}

function sendSmsConfirmationCode(e) {
    var gsmNumber = $(".UyeOlModal #Gsm").val();
    if (gsmNumber != undefined && gsmNumber.length == 13) {
        clearAndHidErrorAlertResult();
        $(".AjaxLoader").show();
        var gRecaptchaResponse = $("input[name='cf-turnstile-response']").val();
        var form = $(this).closest("form");
        $.ajax({
            type: 'POST',
            url: '/' + $("#SmallLangCode").val() + '/p/User/SendConfirmationSms?gsm=' + gsmNumber + '&gc=' + gRecaptchaResponse,
            success: function (dt) {
                if (dt.Sonuc) {
                    // Hata varsa temizle
                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").removeClass("alert-danger");
                    $("#AlertResult").html("");
                    $("#AlertResult").hide();

                    if (dt.Deger10 === "SkipSms") {
                        RegisterSubmit();
                        return;
                    }

                           // Onay kodu Modal'ı aç
                    $("#smsConfirmationModal").show();
                    $("#smsConfirmationModal .smsConfirmationInfoLabel").html("Lütfen " + gsmNumber + " numaralı telefona gelen SMS onay kodunu giriniz!");
                    $("#smsConfirmationModal #lastSenderDate").val(dt.Deger5);
                    SendSmsCountDown();


                } else {
                    ClearCloudflareWidgets();
                    showErrorAlertResult(dt.IslemSonucAciklama);
                }
            }
        });
        $(".AjaxLoader").hide();
    } else {
        showErrorAlertResult("Lütfen telefon numaranızı istenilen formatta giriniz (999 999 99 99)")
    }
    e.preventDefault;
}

function RegisterSubmit() {
    var form = $("#LoginRegisterPage .UyeOlModal");
    $("#LoginRegisterPage .UyeOlModal #Gsm").attr("disabled", false);// .serialize methodu 'disabled' attributune sahip 
    $("#RegisterButton").attr("disabled", "disabled");
    $(".AjaxLoader").show();

    $.ajax({
        type: "POST",
        url: form.attr("action"),
        data: form.serialize(),
        dataType: "json",
        success: function (dt) {

            $(".AjaxLoader").hide();
            $("#RegisterButton").removeAttr("disabled");

            if (dt.Sonuc == true) {

                //  console.log("signup", "userId:", dt.Deger8, "email_permission:", dt.Field1, "sms_permission", dt.Field2);

                DataLayerLoginSignUp("signup", dt.Deger8, dt.Field1, dt.Field2);

                if (UseTagManager) {
                    AddUserAction("Signup");
                }

                if (dt.JsonRs == "Redirect") {
                    form.hide();
                    $(".AjaxLoader").show();
                    $(".RwRegisterLogin").hide();

                    document.location = "/";
                }

                if (dt.JsonRs == "Reload") {

                    form.hide();
                    $(".AjaxLoader").show();
                    $(".RwRegisterLogin").hide();
                    document.location.reload();
                }

                $("#AlertResult").removeClass("alert-error");
                $("#AlertResult").hide();

                //$("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);
            }
            else {
                ClearCloudflareWidgets();
                $("#AlertResult").removeClass("alert-success");
                $("#AlertResult").addClass("alert-error").show().html(dt.IslemSonucAciklama);
            }
        },
        error: function () {

            alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
        }
    });
}

$("#smsConfirmationModal #testTimer").live("click", function () {
    SendSmsCountDown();
})

function SendSmsCountDown() {
    var treeMinutes = 60 * 3;
    startTimer(treeMinutes)
}

function startTimer(duration) {
    var timer = duration, minutes, seconds;
    var interval = setInterval(function () {
        minutes = parseInt(timer / 60, 10)
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        $("#smsConfirmationModal #timerText").html(minutes + ":" + seconds);

        if (--timer < 0) {
            $("#smsConfirmationModal #timerText").html("");
            $("#smsConfirmationModal #retryConfirmationBtn").removeClass("hidden");
            clearInterval(interval);
        }
    }, 1000);
}

// Hata mesajını göster
function showErrorAlertResult(message) {
    $("#AlertResult").html(message);
    $("#AlertResult").addClass("alert-danger");
    $("#AlertResult").show();
    $("html, body").animate({ scrollTop: 0 }, "slow");
};
// Hata div'in gizle ve temizle
function clearAndHidErrorAlertResult() {
    $("#AlertResult").html("");
    $("#AlertResult").remove("alert-danger");
    $("#AlertResult").hide();
}